import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchBalanceSheet } from '@apis/fundamentals';
import type { BalanceSheetApiData } from '@app-types/performanceTrendsApi';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

/**
 * React Query hook for the 貸借対照表 section
 * (GET /api/fundamentals/balance-sheet). Reads ticker/mkt from the router
 * location so URL changes refetch; stays disabled until a token is available.
 */
export const useBalanceSheet = () => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);
  const hasToken = Boolean(getAccessToken());

  return useQuery<BalanceSheetApiData>({
    queryKey: ['fundamentals', 'balance-sheet', ticker, mkt],
    queryFn: () => fetchBalanceSheet({ ticker: ticker as string, mkt: mkt as string }),
    enabled: Boolean(ticker && mkt && hasToken),
    staleTime: 60_000,
    retry: 1,
  });
};
